module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Book Description")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_c('i', [_vm._v("Wild Blue U: Foundation of Honor—The Officer")]), _vm._v(" continues the historical saga chronicling the United States Air Force Academy. "), _c('i', [_vm._v("The Officer")]), _vm._v(" unveils the arduous training of America’s leaders, showcasing empathetic, larger-than-life characters set against a fascinating tapestry of vivid, history-changing events that affect the course of the nation, ranging from cheating scandals at the USAF Academy to the Cuban missile crisis and the jungles of Vietnam.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0